import { match } from 'ts-pattern';

export function useOdeonCustomisation() {
    const taskTypeLabel = (taskType: string) =>
        match<string, string>(taskType)
            .with('harvester', () => `Data Collection`)
            .with('mapping', () => `Semantic Mapping`)
            .with('cleaning', () => `Quality Enhancement`)
            .with('anonymisation', () => `Data  Anonymizer`)
            .with('encryption', () => `Encryption Engine`)
            .with('loader', () => `Data Sovereignty`)
            .otherwise(() => taskType);
    return { taskTypeLabel };
}
